firebird.filter('firstNameLastInitial', function () {
    return function (filterInput) {
        if (typeof filterInput !== 'string') {
            return filterInput;
        }

        var firstName = filterInput.split(' ')[0];
        var lastName = filterInput.split(' ')[1];

        return firstName + (lastName ? ' ' + lastName.charAt(0) : '');
    };
});
